var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-tour-step-header",class:[
    ("__" + _vm.size)
  ]},[_c('div',{staticClass:"m-tour-step-header__text"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"m-tour-step-header__close"},[_c('CloseButton',{attrs:{"large":true,"with-border":false},on:{"click":function($event){return _vm.$emit('stop')}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }